<template>
  <div class="section-report">
    <el-date-picker
      v-model="date"
      type="date"
      :picker-options="pickerOpt"
      placeholder="选择日期"
      @change="pickDate"
    />
    <span class="date-tip">最新更新时间：{{ updateDate }}</span>
    <div class="card-ctn">
      <Card :info="income" />
      <Card :info="customer" />
      <Card :info="arpu" />
    </div>
  </div>
</template>

<script>
import Card from './Card';
import moment from 'moment';
import Request from '@/core/QuRequest';

const req = new Request();

export default {
  name: 'SectionCards',
  components: {
    Card,
  },
  data() {
    return {
      updatedDate: '', // 最新更新日期
      date: '',
      cardInfo: {
        income: {},
        customer: {},
        arpu: {},
      },
      pickerOpt: {
        disabledDate: function(date) {
          return Number(new Date(date)) > Number(new Date());
        },
      },
    };
  },
  computed: {
    income() {
      let rawInfo = this.cardInfo.income || {};
      return {
        cardName: '业绩收入',
        cardLogo: require('@/assets/image/icon/income-icon.png'),
        bottomDesc: '过去7天日均消耗额',
        tip: '您名下，所选日期所有客户的消耗',
        data: rawInfo.total ? `¥ ${rawInfo.total}` : '--',
        last_week_ratio: rawInfo.last_week_ratio || 0,
        yesterday_ratio: rawInfo.yesterday_ratio || 0,
        last_week_average: rawInfo.last_week_average
          ? `¥${rawInfo.last_week_average}`
          : '--',
      };
    },
    customer() {
      let rawInfo = this.cardInfo.customer || {};
      return {
        cardName: '活跃客户数',
        cardLogo: require('@/assets/image/icon/tie-icon.png'),
        bottomDesc: '过去7日日均客户活跃数',
        tip: '您名下，所选日期所有有消耗的客户数',
        data: rawInfo.total ? rawInfo.total : '--',
        last_week_ratio: rawInfo.last_week_ratio || 0,
        yesterday_ratio: rawInfo.yesterday_ratio || 0,
        last_week_average: rawInfo.last_week_average || '--',
      };
    },
    arpu() {
      let rawInfo = this.cardInfo.arpu || {};
      return {
        cardName: 'ARPU',
        cardLogo: require('@/assets/image/icon/arpu-icon.png'),
        bottomDesc: '过去7日日均ARPU',
        tip: '您名下，所选日期所有客户的平均消耗',
        data: rawInfo.total ? `¥ ${rawInfo.total}` : '--',
        last_week_ratio: rawInfo.last_week_ratio || 0,
        yesterday_ratio: rawInfo.yesterday_ratio || 0,
        last_week_average: rawInfo.last_week_average
          ? `¥${rawInfo.last_week_average}`
          : '--',
      };
    },
    updateDate() {
      return moment(this.updatedDate).format('YYYY-MM-DD');
    },
  },

  created() {
    this._getUpdatedDate().then((date) => {
      this.updatedDate = new Date(date);
      this.date = moment(new Date(date)).format('YYYY-MM-DD');
      this._fetchCardsData();
    });
  },

  methods: {
    pickDate(val) {
      this.date = moment(new Date(val)).format('YYYY-MM-DD');
      this._fetchCardsData();
    },

    async _getUpdatedDate() {
      try {
        const res = await req.send(req.Apis.sales.customer.newDate);
        return (res.data || {}).date || new Date();
      } catch (err) {
        this.$message.error(`获取失败：${err.message || '未知错误'}`);
      }
    },

    async _fetchCardsData() {
      try {
        const params = {
          date: this.date,
        };
        // req
        const res = await req.send(
          req.Apis.sales.report.dataCustomerDay,
          params,
        );
        this.cardInfo = res.data;
      } catch (err) {
        this.$message.error(`获取销售信息失败：${err.message || '未知错误'}`);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.card-ctn {
  margin-top: 25px;
}
.date-tip {
  padding-left: 16px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(192, 196, 204, 1);
}
</style>
